import { RESULT_BACKGROUNDS, RESULT_RATIOS } from "../resultAssets";
import { TEXT_STYLES } from "../resultTheme";
import {
    COMMON_NIGHT_ZONES,
    TC_DAY_ZONES,
    TC_POST_TYPOGRAPHY,
    createStandardLayout, NIGHT_A_GROUP,
} from "./sharedLayouts";


const DAY_LO_LAYOUT = {
    rowGap: "1.6%",
    columnGap: "3%",
    columns: 2,
};

const NIGHT_LO_LAYOUT = {
    rowGap: "1.4%",
    columnGap: "3%",
    columns: 2,
};

export const tcConfig = {
    bg: RESULT_BACKGROUNDS.TC,
    layout: {
        DAY: createStandardLayout({
            ratio: RESULT_RATIOS.TC.DAY,
            zones: TC_DAY_ZONES,
            postArea: {
                frame: { left: 12, width: 33.5 },
                rows: {
                    startTop: 27,
                    rowHeight: 6.03,
                },
            },
            postTypography: TC_POST_TYPOGRAPHY,
            loLayout: DAY_LO_LAYOUT,
            textStyle: TEXT_STYLES.tc,
        }),
        NIGHT: createStandardLayout({
            ratio: RESULT_RATIOS.TC.NIGHT,
            zones: COMMON_NIGHT_ZONES,
            postArea: {
                frame: { left: 12, width: 33.5 },
                rows: {
                    startTop: 45,
                    rowHeight: 8.8,
                },
            },
            postTypography: TC_POST_TYPOGRAPHY,
            loLayout: NIGHT_LO_LAYOUT,
            aGroup: NIGHT_A_GROUP,
            textStyle: TEXT_STYLES.tc,
            postGroups: [
                {
                    codes: ["B", "C", "D"],
                    startTop: 45.5,
                    rowHeight: 8.5,
                },
            ],
        }),
    },
};
